import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import DatapickListItem from './DatapickListItem';
import './ServiceTable.css';

class DatapickTable extends React.Component {
  columnsCount = () => 10;

  renderHeader = () => {
    const { translate } = this.props;

    return (
      <thead>
        <tr className="report-table-header_service">
          <th className="report-table-th_service">{translate('service_report.column_task.user')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.employeeId')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.date')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.customer')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.end_customer')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.address')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.city')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.service_site')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.service')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.productId')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.productAmount')}</th>
        </tr>
      </thead>
    );
  };

  renderLoadingInfo = () => {
    const { translate, isLoading } = this.props;
    return isLoading
      ? (
        <React.Fragment>
          <tr className="report-table-row_service">
            <td colSpan={this.columnsCount()}
                className="report-table-cell_service_no_border">
              {translate('service_report.search.loading')}
            </td>
          </tr>
        </React.Fragment>
      )
      : null;
  };

  renderResult = () => {
    const {
      translate, data, isLoading, currentLanguage,
    } = this.props;
    if (isLoading) {
      return null;
    }

    const viewData = data.length > 0
      ? data.slice()
      : [];

    return (
      <React.Fragment>
        {viewData.length === 0 && (
          <tr>
            <td colSpan={this.columnsCount()}>
              {translate('service_report.search.no_data_found')}
            </td>
          </tr>
        )}

        {viewData.map((task) => (
          <DatapickListItem key={task.orderId}
                            item={task}
                            currentLanguage={currentLanguage} />
        ))}
      </React.Fragment>
    );
  };

  render() {
    return (
      <div>
        <table className="report-table_service">
          {this.renderHeader()}
          <tbody>
            {this.renderLoadingInfo()}
            {this.renderResult()}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);

  return {
    currentLanguage: activeLanguage?.code || 'fi',
    translate: getTranslate(locale),
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(DatapickTable);
